import React from 'react';
import { OffthreadVideo } from 'remotion';
import { LayerWrapper } from './LayerWrapper';
import type { BackgroundLayer as BackgroundLayerConfig, UploadedAsset } from '../../types';

interface BackgroundLayerProps {
  layer: BackgroundLayerConfig;
  asset?: UploadedAsset;
}

export function BackgroundLayer({ layer, asset }: BackgroundLayerProps) {
  const { position, animation, opacity, fallbackColor } = layer;

  return (
    <LayerWrapper position={position} animation={animation} opacity={opacity}>
      {asset ? (
        asset.type === 'video' ? (
          // OffthreadVideo is used for server-side rendering.
          // In browser preview mode the Remotion Player falls back to a <video> element.
          <OffthreadVideo
            src={asset.url}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            muted={layer.muted ?? true}
          />
        ) : (
          // Use a plain <img> so that blob: URLs work in both browser preview
          // and server-side rendering without Remotion's image loading overhead.
          <img
            src={asset.url}
            alt=""
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        )
      ) : (
        <div style={{ width: '100%', height: '100%', backgroundColor: fallbackColor }} />
      )}
    </LayerWrapper>
  );
}
